/* eslint-disable no-unused-vars */
import { useState, useEffect, useMemo, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import { isIPad13 } from "react-device-detect";
import dayjs from "dayjs";

import PropTypes from "prop-types";

import { Button, Col, Container, Modal, Row } from "react-bootstrap";

import {
  getRegulatoryStream,
  getTop5Publisher,
  getTop5Countries,
  getHotTopicsPerBusiness,
  getGraphAggregationsDetails,
  deleteNewsById,
  // editNewsItem,
  // addNewsItem,
  getGraphAggregations,
  addNewsItemAction,
  editNewsItemAction,
  filterSuccessMessageRaised,
  filterFailureMessageRaised,
  regulatoryStreamsAreClean,
} from "../../actions/filterActions";

import { WORKSPACE_TYPE_PRIVATE } from "../../constants/stringConstants";
import {
  ADD_NEWS,
  EDIT_NEWS,
  GET_REGULATORY_STREAM,
} from "../../constants/urls";

import TabsCustom from "../../utils/TabsCustom";
import ErrorMessage from "../../utils/ErrorMessage";
import AlertMessage from "../../utils/AlertMessage";
import useWindowDimensions from "../../utils/useWindowDimensions";

import iconsShare from "../../assets/svg/icons-share.svg";
import iconsJson from "../../assets/svg/icons-json.svg";

import SearchOverviewSmallScreen from "./SearchOverviewSmallScreen";
import SearchOverviewLargeScreen from "./SearchOverviewLargeScreen";
import Footer from "../FooterComponents/Footer";
import CustomModal from "../../utils/CustomModal";
import FieldsInForm from "../../utils/FieldsInForm";
import { formatDate } from "../../utils/formatDate";
import axios from "axios";

const STREAM_PAGE_MAX_SIZE = 10;
const STREAM_PAGE_NUMBER = 0;

const SearchTopicContainer = ({
  userToken,
  loggedIn,
  getRegulatoryStream,
  getTop5Publisher,
  getTop5Countries,
  getHotTopicsPerBusiness,
  getGraphAggregationsDetails,
  filterSuccessMessage,
  filterFailureMessage,
  currentWorkspace,
  regulatoryStream,
  filtersTypes,
  singleTopic,
  graphAggregationsDetails,
  // editNewsItem,
  deleteNewsById,
  // addNewsItem,
  getGraphAggregations,
}) => {
  const { free_text } = useParams();
  const [newsDate, setNewsDate] = useState("");
  const [newsTopics, setNewsTopics] = useState([]);
  const [editNewsModal, setEditNewsModal] = useState(null);
  const [submitNewsOccurred, setSubmitNewsOccurred] = useState(false);
  const [addNewsModal, setAddNewsModal] = useState(false);
  const [submitEditNewsOccurred, setSubmitEditNewsOccurred] = useState(false);
  const [newsDateEditForm, setNewsDateEditForm] = useState("");
  const [newsTopicsEditForm, setNewsTopicsEditForm] = useState([]);
  const [topicsAndUnitsDataSet, setTopicsAndUnitsDataSet] = useState([]);
  const [countriesDataSet, setCountriesDataSet] = useState([]);
  const [publisherTypesDataSet, setPublisherTypesDataSet] = useState([]);
  const [publicationTypesDataSet, setPublicationTypesDataSet] = useState([]);
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("DESC");
  const [page, setPage] = useState(1);
  const [freeText, setFreeText] = useState("");
  const [newsIdForDeletion, setNewsIdForDeletion] = useState(null);
  const dispatch = useDispatch();

  const showDeleteNewsModal = useCallback((id) => {
    setNewsIdForDeletion(id);
  }, []);

  const hideDeleteNewsModal = useCallback(() => {
    setNewsIdForDeletion(null);
  }, []);
  const getTopicNameFromStorage = sessionStorage.getItem("TOPIC_SEARCHTAGS");
  const topicsAndUnits = JSON.parse(sessionStorage.getItem("topicsAndUnits"));
  const approveDeleteNewsModal = useCallback(async () => {
    deleteNewsById(userToken, newsIdForDeletion);
    hideDeleteNewsModal();
    dispatch(regulatoryStreamsAreClean());
    // setPage(getPageFromStore);

    let publication = sessionStorage.getItem("publicationTypes");
    let country = sessionStorage.getItem("country");
    let publisher = sessionStorage.getItem("publisherTypes");
    let from = sessionStorage.getItem("fromDate");
    let to = sessionStorage.getItem("toDate");
    let topicsAndUnitsTypesString = "";
    topicsAndUnits?.forEach((topicOrUnit) => {
      topicsAndUnitsTypesString += topicOrUnit.description + ";";
    });
    setTimeout(() => {
      getRegulatoryStream(
        userToken,
        singleTopic.TOPIC_ID,
        freeText,
        getTopicNameFromStorage,
        publication,
        from,
        to,
        publisher,
        country,
        topicsAndUnitsTypesString,
        STREAM_PAGE_NUMBER,
        STREAM_PAGE_MAX_SIZE,
        sortField,
        "DESC"
      );
    }, 1000);
  }, [
    deleteNewsById,
    dispatch,
    freeText,
    getRegulatoryStream,
    getTopicNameFromStorage,
    hideDeleteNewsModal,
    newsIdForDeletion,
    singleTopic.TOPIC_ID,
    sortField,
    topicsAndUnits,
    userToken,
  ]);

  const handlePagination = useCallback(async () => {
    await getRegulatoryStream(
      userToken,
      "",
      freeText,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      page,
      STREAM_PAGE_MAX_SIZE,
      sortField,
      sortDirection
    );
    setPage((prev) => prev + 1);
  }, [
    freeText,
    getRegulatoryStream,
    page,
    sortDirection,
    sortField,
    userToken,
  ]);

  const [
    graphAggregationsDetailsFormatted,
    setGraphAggregationsDetailsFormatted,
  ] = useState([]);
  const { t } = useTranslation(),
    { width } = useWindowDimensions(),
    [selectedTab, setSelectedTab] = useState("overview"),
    [isShared, setIsShared] = useState(),
    tabsObject = {
      classNameOfTabContainer: "tabs-main-container",
      classNameOfTabs: "main-tabs",
      defaultActiveKey: "overview",
      tabs: [
        {
          disabled: false,
          eventKey: "overview",
          tabClassName: "main-tab overviewTab",
          title: t("overview"),
          component:
            width > 1024 && !isIPad13 ? (
              <>
                <SearchOverviewLargeScreen
                  setEditNewsModal={setEditNewsModal}
                  filterSuccessMessage={filterSuccessMessage}
                  filterFailureMessage={filterFailureMessage}
                  setSortField={setSortField}
                  graphAggregationsDetailsFormatted={
                    graphAggregationsDetailsFormatted
                  }
                  handlePagination={handlePagination}
                  showDeleteNewsModal={showDeleteNewsModal}
                  setAddNewsModal={setAddNewsModal}
                />
              </>
            ) : (
              <>
                <SearchOverviewSmallScreen
                  setEditNewsModal={setEditNewsModal}
                  filterSuccessMessage={filterSuccessMessage}
                  filterFailureMessage={filterFailureMessage}
                  setSortField={setSortField}
                  graphAggregationsDetailsFormatted={
                    graphAggregationsDetailsFormatted
                  }
                  handlePagination={handlePagination}
                  showDeleteNewsModal={showDeleteNewsModal}
                  setAddNewsModal={setAddNewsModal}
                />
              </>
            ),
        },
      ],
    },
    [didMount, setDidMount] = useState(false),
    [otherRequestCalled, setOtherRequestCalled] = useState(false);
  const addNewsFields = {
    fields: [
      {
        name: "NEWS_TITLE",
        type: "text",
        className: "news-title-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsTitle"),
        placeholder: t("newsTitlePlaceholder"),
      },
      {
        name: "NEWS_URL",
        type: "text",
        className: "news-url-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsURL"),
        placeholder: t("newsURLPlaceholder"),
      },
      {
        name: "NEWS_DESCRIPTION",
        type: "textarea",
        className: "news-description-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsDescription"),
        placeholder: t("newsDescriptionPlaceholder"),
      },
      {
        name: "NEWS_CONTENT",
        type: "textarea",
        className: "news-content-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsContent"),
        placeholder: t("newsContentPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER",
        type: "text",
        className: "news-publisher-text-field",
        required: true,
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsPublisher"),
        placeholder: t("newsPublisherPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER_TYPE",
        type: "select",
        className: "news-publisher-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...publisherTypesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublisherType"),
      },
      {
        name: "NEWS_PUBLICATION_TYPE",
        type: "select",
        className: "news-publication-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          ...publicationTypesDataSet,
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublicationType"),
      },
      {
        name: "NEWS_DATE",
        type: "date",
        className: "news-date-field",
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsDate"),
        required: true,
        options: [
          {
            key: "news-date",
            name: "NEWS_DATE",
            format: "YYYY/MM/DD",
            type: "date",
            disabled: false,
            value: formatDate(newsDate),
            onChangeDate: (value) => {
              setNewsDate(new Date(value));
            },
          },
        ],
      },
      {
        name: "NEWS_COUNTRY",
        type: "select",
        className: "news-country-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...countriesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCountry"),
      },
      {
        name: "NEWS_TOPICS",
        type: "multi-select",
        className: "news-topics-type-multiselect",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: topicsAndUnitsDataSet,
        selectedOptions: newsTopics,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsTopics"),
        placeholder: t("newsTopicsPlaceholder"),
        onMultiSelectOptionChanged: (value, description) => {
          let found = newsTopics.find((el) => {
            return el.value === value;
          });

          if (!found) {
            setNewsTopics((newsTopics) => [
              ...newsTopics,
              {
                description: description,
                value: value,
              },
            ]);
          }
        },
        onMultiSelectOptionRemoved: (value) => {
          setNewsTopics(newsTopics.filter((o) => o.value !== value));
        },
      },
      {
        name: "NEWS_CURATED",
        type: "select",
        className: "news-curated-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          { description: "No", value: "no" },
          { description: "Yes", value: "yes" },
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCurated"),
      },
    ],

    findFormErrors: (form) => {
      const {
        NEWS_DESCRIPTION,
        NEWS_TITLE,
        NEWS_URL,
        NEWS_CONTENT,
        NEWS_PUBLISHER,
        NEWS_PUBLISHER_TYPE,
        NEWS_PUBLICATION_TYPE,
        NEWS_DATE,
        NEWS_COUNTRY,
        NEWS_CURATED,
      } = form;
      const newsErrors = {};
      console.log("newsErrors Search  TOPIC PAGE :>> ", newsErrors);

      if (!NEWS_TITLE || NEWS_TITLE === "") {
        newsErrors.NEWS_TITLE = "News title is mandatory field";
      }
      if (!NEWS_URL || NEWS_URL === "") {
        newsErrors.NEWS_URL = "News URL is mandatory field";
      }
      if (!NEWS_CONTENT || NEWS_CONTENT === "") {
        newsErrors.NEWS_CONTENT = "News content is mandatory field";
      }
      if (!NEWS_DESCRIPTION || NEWS_DESCRIPTION === "") {
        newsErrors.NEWS_DESCRIPTION = "News description is mandatory field";
      }
      if (NEWS_DESCRIPTION && NEWS_DESCRIPTION.length > 1500)
        newsErrors.NEWS_DESCRIPTION =
          "News description can't be longer than 1500 charachteres";
      if (!NEWS_PUBLISHER || NEWS_PUBLISHER === "") {
        newsErrors.NEWS_PUBLISHER = "News publisher is mandatory field";
      }
      if (
        !NEWS_PUBLISHER_TYPE ||
        NEWS_PUBLISHER_TYPE === "" ||
        NEWS_PUBLISHER_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLISHER_TYPE =
          "News publisher type is mandatory field";
      }
      if (
        !NEWS_PUBLICATION_TYPE ||
        NEWS_PUBLICATION_TYPE === "" ||
        NEWS_PUBLICATION_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLICATION_TYPE =
          "News publication type is mandatory field";
      }
      if (!NEWS_DATE || NEWS_DATE === "") {
        newsErrors.NEWS_DATE = "News date is mandatory field";
      }
      if (
        !NEWS_COUNTRY ||
        NEWS_COUNTRY === "" ||
        NEWS_COUNTRY === "Please select"
      ) {
        newsErrors.NEWS_COUNTRY = "News country is mandatory field";
      }
      if (
        !NEWS_CURATED ||
        NEWS_CURATED === "" ||
        NEWS_CURATED === "Please select"
      ) {
        newsErrors.NEWS_CURATED = "News curated is mandatory field";
      }

      return newsErrors;
    },

    onSubmit: (values) => {
      let newsTopicsArr = [];
      newsTopics.map((item) => newsTopicsArr.push(item.description));
      let newsTopicsString = newsTopicsArr.join(";");

      let newsValues = {
        ...values,
        NEWS_TOPICS: newsTopicsString,
        NEWS_CURATED: values?.NEWS_CURATED || "no",
      };
      // addNewsItem(
      //   userToken,
      //   newsValues.NEWS_TITLE,
      //   newsValues.NEWS_DESCRIPTION,
      //   newsValues.NEWS_CONTENT,
      //   newsValues.NEWS_COUNTRY,
      //   newsValues.NEWS_URL,
      //   newsValues.NEWS_PUBLICATION_TYPE,
      //   newsValues.NEWS_PUBLISHER,
      //   newsValues.NEWS_PUBLISHER_TYPE,
      //   newsValues.NEWS_DATE,
      //   newsValues.NEWS_CURATED,
      //   singleTopic.TOPIC_SEARCHTAGS + ";" + newsValues.NEWS_TOPICS
      // );
      let data = new Date(newsValues.NEWS_DATE);
      let year = data.getUTCFullYear();
      let month = data.getUTCMonth();
      let day = data.getUTCDay();
      let string = `${year}-${month}-${day}`;

      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let bodyFormData = new FormData();
      bodyFormData.append("usertoken", userToken);
      bodyFormData.append("news_title", newsValues.NEWS_TITLE);
      bodyFormData.append("description", newsValues.NEWS_DESCRIPTION);
      bodyFormData.append("content", newsValues.NEWS_CONTENT);
      bodyFormData.append("country", newsValues.NEWS_COUNTRY);
      bodyFormData.append("url", newsValues.NEWS_URL);
      bodyFormData.append("publication_type", newsValues.NEWS_PUBLICATION_TYPE);
      bodyFormData.append("publisher", newsValues.NEWS_PUBLISHER);
      bodyFormData.append("publisher_type", newsValues.NEWS_PUBLISHER_TYPE);
      bodyFormData.append("publication_date", string);
      bodyFormData.append(
        "topics",
        singleTopic.TOPIC_SEARCHTAGS + ";" + newsValues.NEWS_TOPICS
      );
      bodyFormData.append("curated", newsValues.NEWS_CURATED);

      const asStringAdd = new URLSearchParams(bodyFormData).toString();

      axios
        .post(ADD_NEWS, asStringAdd, axiosConfig)
        .then((response) => {
          dispatch(addNewsItemAction(response.data.RegHub_response));
          dispatch(
            filterSuccessMessageRaised("The news has been added successfully.")
          );
        })
        .catch((err) => {
          dispatch(
            filterFailureMessageRaised(err.response ? err.response.data : err)
          );
        });
      setAddNewsModal(false);
    },
  };
  const [formErrors, setFormErrors] = useState({});

  const editNewsFields = {
    fields: [
      {
        name: "NEWS_TITLE",
        type: "text",
        className: "news-title-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsTitle"),
        placeholder: t("newsTitlePlaceholder"),
      },
      {
        name: "NEWS_URL",
        type: "text",
        className: "news-url-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsURL"),
        placeholder: t("newsURLPlaceholder"),
      },
      {
        name: "NEWS_DESCRIPTION",
        type: "textarea",
        className: "news-description-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsDescription"),
        placeholder: t("newsDescriptionPlaceholder"),
      },
      {
        name: "NEWS_CONTENT",
        type: "textarea",
        className: "news-content-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsContent"),
        placeholder: t("newsContentPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER",
        type: "text",
        className: "news-publisher-text-field",
        required: true,
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsPublisher"),
        placeholder: t("newsPublisherPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER_TYPE",
        type: "select",
        className: "news-publisher-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...publisherTypesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublisherType"),
      },
      {
        name: "NEWS_PUBLICATION_TYPE",
        type: "select",
        className: "news-publication-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          ...publicationTypesDataSet,
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublicationType"),
      },
      {
        name: "NEWS_DATE",
        type: "date",
        className: "news-date-field",
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsDate"),
        required: true,
        options: [
          {
            key: "news-date",
            name: "NEWS_DATE",
            format: "YYYY/MM/DD",
            type: "date",
            disabled: false,
            value: formatDate(newsDateEditForm),
            onChangeDate: (value) => {
              setNewsDateEditForm(new Date(value));
            },
          },
        ],
      },
      {
        name: "NEWS_COUNTRY",
        type: "select",
        className: "news-country-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...countriesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCountry"),
      },
      {
        name: "NEWS_TOPICS",
        type: "multi-select",
        className: "news-topics-type-multiselect",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: topicsAndUnitsDataSet,
        selectedOptions: newsTopicsEditForm,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsTopics"),
        placeholder: t("newsTopicsPlaceholder"),
        onMultiSelectOptionChanged: (value, description) => {
          let found = newsTopicsEditForm.find((el) => {
            return el.value === value;
          });

          if (!found) {
            setNewsTopicsEditForm((newsTopicsEditForm) => [
              ...newsTopicsEditForm,
              {
                description: description,
                value: value,
              },
            ]);
          }
        },
        onMultiSelectOptionRemoved: (value) => {
          setNewsTopicsEditForm(
            newsTopicsEditForm.filter((o) => o.value !== value)
          );
        },
      },
      {
        name: "NEWS_CURATED",
        type: "select",
        className: "news-curated-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          { description: "No", value: "no" },
          { description: "Yes", value: "yes" },
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCurated"),
      },
    ],

    findFormErrors: (form) => {
      const {
        NEWS_DESCRIPTION,
        NEWS_TITLE,
        NEWS_URL,
        NEWS_PUBLISHER,
        NEWS_PUBLISHER_TYPE,
        NEWS_PUBLICATION_TYPE,
        NEWS_COUNTRY,
        NEWS_CURATED,
      } = form;
      const newsErrors = {};

      if (!NEWS_TITLE || NEWS_TITLE === "") {
        newsErrors.NEWS_TITLE = "News title is mandatory field";
      }
      if (!NEWS_URL || NEWS_URL === "") {
        newsErrors.NEWS_URL = "News URL is mandatory field";
      }
      // if (!NEWS_DESCRIPTION || NEWS_DESCRIPTION === "") {
      //   newsErrors.NEWS_DESCRIPTION = "News description is mandatory field";
      // }
      if (NEWS_DESCRIPTION && NEWS_DESCRIPTION.length > 1500)
        newsErrors.NEWS_DESCRIPTION =
          "News description can't be longer than 1500 charachteres";
      if (!NEWS_PUBLISHER || NEWS_PUBLISHER === "") {
        newsErrors.NEWS_PUBLISHER = "News publisher is mandatory field";
      }
      if (
        !NEWS_PUBLISHER_TYPE ||
        NEWS_PUBLISHER_TYPE === "" ||
        NEWS_PUBLISHER_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLISHER_TYPE =
          "News publisher type is mandatory field";
      }
      if (
        !NEWS_PUBLICATION_TYPE ||
        NEWS_PUBLICATION_TYPE === "" ||
        NEWS_PUBLICATION_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLICATION_TYPE =
          "News publication type is mandatory field";
      }
      if (
        !NEWS_COUNTRY ||
        NEWS_COUNTRY === "" ||
        NEWS_COUNTRY === "Please select"
      ) {
        newsErrors.NEWS_COUNTRY = "News country is mandatory field";
      }
      if (
        !NEWS_CURATED ||
        NEWS_CURATED === "" ||
        NEWS_CURATED === "Please select"
      ) {
        newsErrors.NEWS_CURATED = "News curated is mandatory field";
      }
      setFormErrors(newsErrors);
      return newsErrors;
    },

    onSubmit: (values) => {
      let newsTopicsArr = [];
      newsTopicsEditForm.map((item) => newsTopicsArr.push(item.description));
      let newsTopicsString = newsTopicsArr.join(";");

      let editNewsValues = {
        ...values,
        NEWS_ID: editNewsModal,
        NEWS_TOPICS: newsTopicsString,
        NEWS_DATE: formatDate(newsDateEditForm),
        NEWS_CURATED: values?.NEWS_CURATED || "no",
      };
      // editNewsItem(
      //   editNewsValues.NEWS_ID,
      //   userToken,
      //   editNewsValues.NEWS_TITLE,
      //   editNewsValues.NEWS_DESCRIPTION,
      //   editNewsValues.NEWS_CONTENT,
      //   editNewsValues.NEWS_COUNTRY,
      //   editNewsValues.NEWS_URL,
      //   editNewsValues.NEWS_PUBLICATION_TYPE,
      //   editNewsValues.NEWS_PUBLISHER,
      //   editNewsValues.NEWS_PUBLISHER_TYPE,
      //   editNewsValues.NEWS_DATE,
      //   editNewsValues.NEWS_CURATED,
      //   singleTopic.TOPIC_SEARCHTAGS + ";" + editNewsValues.NEWS_TOPICS
      // );

      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let bodyFormData = new FormData();
      bodyFormData.append("usertoken", userToken);
      bodyFormData.append("news_title", editNewsValues.NEWS_TITLE);
      bodyFormData.append("description", editNewsValues.NEWS_DESCRIPTION);
      bodyFormData.append("content", editNewsValues.NEWS_CONTENT);
      bodyFormData.append("country", editNewsValues.NEWS_COUNTRY);
      bodyFormData.append("url", editNewsValues.NEWS_URL);
      bodyFormData.append(
        "publication_type",
        editNewsValues.NEWS_PUBLICATION_TYPE
      );
      bodyFormData.append("publisher", editNewsValues.NEWS_PUBLISHER);
      bodyFormData.append("publisher_type", editNewsValues.NEWS_PUBLISHER_TYPE);
      bodyFormData.append("publication_date", editNewsValues.NEWS_DATE);
      bodyFormData.append(
        "topics",
        newsTopicsString
        // singleTopic.TOPIC_SEARCHTAGS + ";" + editNewsValues.NEWS_TOPICS
      );
      bodyFormData.append("curated", editNewsValues.NEWS_CURATED);
      bodyFormData.append("news_id", editNewsValues.NEWS_ID);

      const asString = new URLSearchParams(bodyFormData).toString();

      axios
        .post(EDIT_NEWS, asString, axiosConfig)
        .then((response) => {
          dispatch(editNewsItemAction(response.data.RegHub_response));
          dispatch(
            filterSuccessMessageRaised("The news has been edited successfully.")
          );
        })
        .catch((err) => {
          dispatch(
            filterFailureMessageRaised(err.response ? err.response.data : err)
          );
        });
      setEditNewsModal(false);
    },
  };
  const editedNews = useMemo(() => {
    return regulatoryStream.find((item) => item.id === editNewsModal);
  }, [editNewsModal, regulatoryStream]);

  useEffect(() => {
    setNewsDateEditForm(editedNews?.news_date);
    if (editedNews) {
      let topics = editedNews.news_topic.filter((item) => !!item.comment);
      let formattedTopics = topics.map((item) => {
        return {
          description: item.description,
          value: item.description,
          comment: item.comment,
        };
      });
      setNewsTopicsEditForm(formattedTopics);
    }
  }, [editNewsModal, editedNews]);

  const formatDate2 = (date) => dayjs(date).format("DD.MM.YYYY");
  const formatDateForRequest = (date) => dayjs(date).format("YYYY-MM-DD");

  const todayDate = formatDateForRequest(Date.now());
  const todayDateYearAgo = formatDateForRequest(
    new Date(new Date().setFullYear(new Date().getFullYear() - 1))
  );

  useEffect(() => {
    if (!didMount) {
      setDidMount(true);
    }

    if ((didMount && !otherRequestCalled) || free_text !== freeText) {
      getGraphAggregations(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getGraphAggregationsDetails(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getTop5Publisher(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getTop5Countries(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getHotTopicsPerBusiness(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getRegulatoryStream(
        userToken,
        "",
        free_text,
        "",
        "",
        todayDateYearAgo,
        todayDate,
        "",
        "",
        "",
        STREAM_PAGE_NUMBER,
        STREAM_PAGE_MAX_SIZE
      );
      setOtherRequestCalled(true);
      setFreeText(free_text);
    }
  }, [
    userToken,
    didMount,
    setDidMount,
    getRegulatoryStream,
    getGraphAggregationsDetails,
    getTop5Publisher,
    getTop5Countries,
    getHotTopicsPerBusiness,
    otherRequestCalled,
    setOtherRequestCalled,
    free_text,
    freeText,
    setFreeText,
    todayDateYearAgo,
    todayDate,
    getGraphAggregations,
  ]);

  useEffect(() => {
    if (
      filtersTypes.length &&
      (!countriesDataSet.length ||
        !publicationTypesDataSet.length ||
        !publisherTypesDataSet.length ||
        !topicsAndUnitsDataSet.length)
    ) {
      if (
        Object.keys(filtersTypes[0]).length &&
        !publisherTypesDataSet.length
      ) {
        // ADDED alphabetical order

        const sortedPublisherTypes = Object.keys(filtersTypes[0])
          .map((publisher_type) => ({
            description: filtersTypes[0][publisher_type],
            value: filtersTypes[0][publisher_type],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setPublisherTypesDataSet(sortedPublisherTypes);
        // Object.keys(filtersTypes[0]).forEach((publisher_type) => {
        //   setPublisherTypesDataSet((publisherTypesDataSet) => [
        //     ...publisherTypesDataSet,
        //     {
        //       description: filtersTypes[0][publisher_type],
        //       value: filtersTypes[0][publisher_type],
        //     },
        //   ]);
        // });
      }

      if (
        Object.keys(filtersTypes[1]).length &&
        !publicationTypesDataSet.length
      ) {
        // ADDED alphabetical order
        const sortedPublisherTypesDataSet = Object.keys(filtersTypes[1])
          .map((publication_type) => ({
            description: filtersTypes[1][publication_type],
            value: filtersTypes[1][publication_type],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setPublicationTypesDataSet(sortedPublisherTypesDataSet);
        // Object.keys(filtersTypes[1]).forEach((publication_type) => {
        //   setPublicationTypesDataSet((publicationTypesDataSet) => [
        //     ...publicationTypesDataSet,
        //     {
        //       description: filtersTypes[1][publication_type],
        //       value: filtersTypes[1][publication_type],
        //     },
        //   ]);
        // });
      }

      if (Object.keys(filtersTypes[2]).length && !countriesDataSet.length) {
        // ADDED alphabetical order
        const sortedCountriesDataSet = Object.keys(filtersTypes[2])
          .map((country) => ({
            description: filtersTypes[2][country],
            value: filtersTypes[2][country],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setCountriesDataSet(sortedCountriesDataSet);
        // Object.keys(filtersTypes[2]).forEach((country) => {
        //   setCountriesDataSet((countriesDataSet) => [
        //     ...countriesDataSet,
        //     {
        //       description: filtersTypes[2][country],
        //       value: filtersTypes[2][country],
        //     },
        //   ]);
        // });
      }

      if (
        Object.keys(filtersTypes[3]).length &&
        !topicsAndUnitsDataSet.length
      ) {
        // ADDED alphabetical order
        const sortedTopicsAndUnitsDataSet = Object.keys(filtersTypes[3])
          .map((topicOrUnit) => ({
            description: filtersTypes[3][topicOrUnit],
            value: filtersTypes[3][topicOrUnit],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setTopicsAndUnitsDataSet(sortedTopicsAndUnitsDataSet);
        // Object.keys(filtersTypes[3]).forEach((topicOrUnit) => {
        //   setTopicsAndUnitsDataSet((topicsAndUnitsDataSet) => [
        //     ...topicsAndUnitsDataSet,
        //     {
        //       description: filtersTypes[3][topicOrUnit],
        //       value: filtersTypes[3][topicOrUnit],
        //     },
        //   ]);
        // });
      }
    }
  }, [
    filtersTypes,
    countriesDataSet.length,
    publicationTypesDataSet.length,
    publisherTypesDataSet.length,
    topicsAndUnitsDataSet.length,
  ]);

  useEffect(() => {
    getRegulatoryStream(
      userToken,
      "",
      freeText,
      "",
      "",
      todayDateYearAgo,
      todayDate,
      "",
      "",
      "",
      STREAM_PAGE_NUMBER,
      STREAM_PAGE_MAX_SIZE,
      sortField,
      sortDirection
    );
  }, [
    sortField,
    todayDate,
    todayDateYearAgo,
    getRegulatoryStream,
    freeText,
    userToken,
    sortDirection,
    singleTopic.TOPIC_ID,
    singleTopic.TOPIC_SEARCHTAGS,
  ]);

  useEffect(() => {
    let graphAggregationsDetailsFormatted = [graphAggregationsDetails[0]];
    if (graphAggregationsDetails) {
      for (let i = 1; i < graphAggregationsDetails.length; i++) {
        let item = graphAggregationsDetails[i];
        let itemDate = item[0];
        let formattedItemDate = formatDate2(itemDate);
        item.shift();
        let formattedItem = [formattedItemDate, ...item];
        graphAggregationsDetailsFormatted.push(formattedItem);
      }
    }
    setGraphAggregationsDetailsFormatted(graphAggregationsDetailsFormatted);
  }, [graphAggregationsDetails]);

  function onShareClick() {
    setIsShared(true);

    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(window.location.href);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = window.location.href;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  }

  function onShareClose() {
    setIsShared(false);
  }

  return !loggedIn ? (
    <Container expand="lg" className="home-page-container">
      <ErrorMessage message={t("onlyForLoggedInUsersAvailable")} />
    </Container>
  ) : (
    <Container
      expand="lg"
      className="home-page-container search-topic-container"
    >
      <>
        <Row className="main-heading-row topic-heading-row">
          <span className={"heading fs-21"}>{free_text}</span>
        </Row>
        <Row className="subline-heading-row">
          <span className={"subheading fs-10"}>{""}</span>
          <span className="topic-subheading-right-options fs-14">
            <span
              className={
                currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE
                  ? "cursor-pointer"
                  : "cursor-not-allowed"
              }
              style={{ paddingRight: "32px" }}
            >
              <Link
                to={GET_REGULATORY_STREAM}
                className={"topic-subheading-options-logged-in"}
                target="_blank"
                onClick={(event) => {
                  event.preventDefault();
                  if (
                    currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE
                  ) {
                    window.open(
                      GET_REGULATORY_STREAM +
                        "?usertoken=" +
                        userToken +
                        "&topic_id=" +
                        "&freeText=" +
                        free_text +
                        "&topic_search_tags=" +
                        "&publicationTypes=" +
                        "&fromDate=" +
                        "&toDate=" +
                        "&publisherTypes=" +
                        "&countries="
                    );
                  }
                }}
              >
                <img
                  width={"24px"}
                  height={"24px"}
                  src={iconsJson}
                  className="topic-subheading-option-icon"
                />
                <span className="topic-subheading-option-label">
                  {t("getJSONStream")}
                </span>
              </Link>
            </span>
            <span
              onClick={() => onShareClick()}
              className={
                "topic-subheading-option cursor-pointer topic-subheading-options-logged-in"
              }
            >
              <img
                width={"24px"}
                height={"24px"}
                src={iconsShare}
                className="topic-subheading-option-icon"
              />
              <span className="topic-subheading-option-label">
                {t("share")}
              </span>
            </span>
          </span>
        </Row>
        <hr className="horizontal-ruler topic-horizontal-ruler" />
        <TabsCustom
          classNameOfTabs={tabsObject.classNameOfTabs}
          defaultActiveKey={tabsObject.defaultActiveKey}
          tabs={tabsObject.tabs}
          classNameOfTabContainer={tabsObject.classNameOfTabContainer}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
        <Footer />
      </>
      {isShared ? (
        <AlertMessage
          variant="success"
          onClose={() => onShareClose()}
          successHeading={t("success")}
          mainMessage={t("copyURLMessage")}
        />
      ) : (
        <div className="display-none" />
      )}

      <Modal centered={true} show={!!newsIdForDeletion} backdrop={true}>
        <Modal.Header>{t("deleteNewMessage")}</Modal.Header>

        <Modal.Footer>
          <Button
            onClick={hideDeleteNewsModal}
            className="modal-negative-button apply-bg-white-color fs-14"
          >
            {t("cancel")}
          </Button>
          <Button
            onClick={approveDeleteNewsModal}
            className="modal-positive-button apply-bg-approx-analog-color approve-news-deletion-btn fs-14"
          >
            {t("yes")}
          </Button>
        </Modal.Footer>
      </Modal>

      <CustomModal
        positiveButton={t("newsSaveBtn")}
        positiveAction={() => setSubmitNewsOccurred(true)}
        titleOfModal={t("addNews")}
        negativeButton={t("close")}
        negativeAction={() => setAddNewsModal(false)}
        isShown={addNewsModal}
        setIsShown={setAddNewsModal}
        isBackdrop="static"
        isCentered={true}
        classNameOfModal="reghub-modal add-news-modal"
        content={
          <FieldsInForm
            idOfForm="add-news-form"
            fields={addNewsFields.fields}
            findFormErrors={addNewsFields.findFormErrors}
            onSubmit={addNewsFields.onSubmit}
            submitOccurred={submitNewsOccurred}
            setSubmitOccurred={setSubmitNewsOccurred}
          />
        }
      />
      {console.log(newsTopicsEditForm)}
      {!!editNewsModal && (
        <CustomModal
          isPositiveButtonDisabled={
            Object.keys(formErrors).length > 0 || newsTopicsEditForm.length < 1
          }
          positiveButton={t("newsSaveBtn")}
          positiveAction={() => setSubmitEditNewsOccurred(true)}
          titleOfModal={t("editNews")}
          negativeButton={t("close")}
          negativeAction={() => setEditNewsModal(null)}
          isShown={!!editNewsModal}
          setIsShown={setEditNewsModal}
          isBackdrop="static"
          isCentered={true}
          classNameOfModal="reghub-modal add-news-modal"
          content={
            <FieldsInForm
              existingData={{
                NEWS_TITLE: editedNews?.news_title,
                NEWS_URL: editedNews?.news_link,
                NEWS_DESCRIPTION: editedNews?.news_summary,
                NEWS_CONTENT: editedNews?.news_content,
                NEWS_PUBLISHER: editedNews?.source_name,
                NEWS_PUBLISHER_TYPE: editedNews?.source_type,
                NEWS_PUBLICATION_TYPE: editedNews?.news_type,
                NEWS_COUNTRY: editedNews?.source_country,
                NEWS_TOPICS: "Recruiting",
                NEWS_CURATED:
                  editedNews?.news_label === "curated" ? "yes" : "no",
              }}
              idOfForm="add-news-form"
              fields={editNewsFields.fields}
              findFormErrors={editNewsFields.findFormErrors}
              onSubmit={editNewsFields.onSubmit}
              submitOccurred={submitEditNewsOccurred}
              setSubmitOccurred={setSubmitEditNewsOccurred}
            />
          }
        />
      )}
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    userToken: state.configReducer.userToken,
    loggedIn: state.userReducer.loggedIn,
    filterFailureMessage: state.filterReducer.filterFailureMessage,
    filterSuccessMessage: state.filterReducer.filterSuccessMessage,
    currentWorkspace: state.configReducer.currentWorkspace,
    regulatoryStream: state.filterReducer.regulatoryStream,
    filtersTypes: state.filterReducer.filtersTypes,
    singleTopic: state.topicReducer.singleTopic,
    graphAggregationsDetails: state.filterReducer.graphAggregationsDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRegulatoryStream: bindActionCreators(getRegulatoryStream, dispatch),
    getTop5Publisher: bindActionCreators(getTop5Publisher, dispatch),
    getTop5Countries: bindActionCreators(getTop5Countries, dispatch),
    getHotTopicsPerBusiness: bindActionCreators(
      getHotTopicsPerBusiness,
      dispatch
    ),
    getGraphAggregationsDetails: bindActionCreators(
      getGraphAggregationsDetails,
      dispatch
    ),
    // editNewsItem: bindActionCreators(editNewsItem, dispatch),
    deleteNewsById: bindActionCreators(deleteNewsById, dispatch),
    // addNewsItem: bindActionCreators(addNewsItem, dispatch),
    getGraphAggregations: bindActionCreators(getGraphAggregations, dispatch),
  };
};

SearchTopicContainer.propTypes = {
  userToken: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  getRegulatoryStream: PropTypes.func.isRequired,
  getTop5Publisher: PropTypes.func.isRequired,
  getTop5Countries: PropTypes.func.isRequired,
  getHotTopicsPerBusiness: PropTypes.func.isRequired,
  getGraphAggregationsDetails: PropTypes.func.isRequired,
  filterFailureMessage: PropTypes.string.isRequired,
  filterSuccessMessage: PropTypes.string.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }).isRequired,
  regulatoryStream: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filtersTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  singleTopic: PropTypes.shape({
    CREATED_BY: PropTypes.string,
    SUBSCRIPTION: PropTypes.string,
    TOPIC_AUDIENCE: PropTypes.string,
    TOPIC_ICON_PATH: PropTypes.string,
    TOPIC_ID: PropTypes.number,
    TOPIC_NAME: PropTypes.string,
    TOPIC_SEARCHTAGS: PropTypes.string,
    TOPIC_STATUS: PropTypes.string,
    SUBSCRIPTION_ID: PropTypes.string,
    TOPIC_TYPE: PropTypes.string,
  }).isRequired,
  graphAggregationsDetails: PropTypes.arrayOf(PropTypes.array).isRequired,
  // editNewsItem: PropTypes.func.isRequired,
  deleteNewsById: PropTypes.func.isRequired,
  // addNewsItem: PropTypes.func.isRequired,
  getGraphAggregations: PropTypes.func.isRequired,
};

SearchTopicContainer.defaultProps = {
  userToken: "",
  loggedIn: false,
  getRegulatoryStream: () => {},
  getTop5Publisher: () => {},
  getTop5Countries: () => {},
  getHotTopicsPerBusiness: () => {},
  getGraphAggregationsDetails: () => {},
  filterFailureMessage: "",
  filterSuccessMessage: "",
  currentWorkspace: {},
  regulatoryStream: [],
  filtersTypes: [],
  singleTopic: {},
  graphAggregationsDetails: [],
  editNewsItem: () => {},
  deleteNewsById: () => {},
  addNewsItem: () => {},
  getGraphAggregations: () => {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchTopicContainer);
